export default __webpack_public_path__ + "static/interUI.369733cb.svg";